module.exports = __webpack_public_path__ + "static/cmr-recruitment-deck-931fea867faec62c8f4a066bb3b55e2d.pdf";